import * as React from 'react';
import { InfoWindow, Marker } from "react-google-maps";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as DTOS from "../../../../../../FeralScan.dtos";
import * as DashboardActionCreators from "../../../../../../actions/dashboard.actions";
import * as DataActionCreators from "../../../../../../actions/data.actions";
import * as MapActionCreators from "../../../../../../actions/map.actions";
import { IAppState } from '../../../../../../app';
import * as Configuration from '../../../../../../configuration';
import { ITab } from '../../../../../../configuration/ICustomConfiguration';
import { MapState, LatLong } from '../../../../../../reducers/map.reducer';
import PlotEdit from '../../../../../Data/Plot/PlotEdit';
import MapContainer from '../../../../../Map/MapContainer';
import { MarkerIcon } from '../../../../../Map/Platypus/MapMarker';
import PlotSummary from '../../../../../Map/Platypus/PlotSummary';
import { IBasePageProps, PlatypusPlotStatus } from '../../../../configuration/IConfiguration';
import InternalClassificationLink from '../../../../Common/Links/InternalClassificationLink';


type PageSiteSelectProps = {
    defaultMarkerIcon: MarkerIcon;
    mapType: string;
    mapGridSize: number;
    mapGoogleMapURL: string;
    mapMarkerComponent: any;
    mapMarkerOutlineColour: string;
}

type PageSiteSelectActions = {
}

type PageSiteSelectRouteParams = {
}

type PageSiteSelectQueryParams = {
}

type PageSiteSelectPropsMapped = {
    map: MapState;
    plotSummaryData: DTOS.PlotSummary[];
    plots: DTOS.Plot[];
    plotSaving: boolean;
    userPlots: DTOS.Plot[];
}

type PageSiteSelectActionsMapped = {
    flagPlot: typeof DashboardActionCreators.flagPlotRequest;
    getPlotSummaryData: typeof DataActionCreators.getPlotSummaryDataRequest;
    getPlots: typeof DataActionCreators.getPlotsRequest;
    onCreatePlot: typeof DashboardActionCreators.createPlotRequest;
    toggleMarkerPopup: typeof MapActionCreators.toggleMarkerPopupRequest;
    toggleNewMarkerPopup: typeof MapActionCreators.toggleNewMarkerPopupRequest;
}

type PageSiteSelectAllPropsInherited = PageSiteSelectProps & PageSiteSelectActions;
type PageSiteSelectAllPropsMapped = PageSiteSelectPropsMapped & PageSiteSelectActionsMapped;

type PageSiteSelectAllProps = IBasePageProps<PageSiteSelectRouteParams, PageSiteSelectQueryParams> & Partial<PageSiteSelectAllPropsMapped> & PageSiteSelectAllPropsInherited;

class PageSiteSelect extends React.Component<PageSiteSelectAllProps, any> {
    constructor(props, context) {
        super(props, context);

        this.generateDataMarkers = this.generateDataMarkers.bind(this);
        this.generateNewMarker = this.generateNewMarker.bind(this);
        this.loadPlots = this.loadPlots.bind(this);
    }

    componentDidMount() {
        this.loadPlots();
    }

    componentDidUpdate(prevProps: PageSiteSelectAllProps) {
        const { plots } = this.props;
        
        if (plots && prevProps.plots != plots) {
            this.props.getPlotSummaryData(plots.map(p => p.id), undefined, undefined, undefined);
        }

        if(prevProps.plotSaving && !this.props.plotSaving)
        {
            this.loadPlots();
        }
    }

    loadPlots(){
        this.props.getPlots(undefined, undefined, undefined, undefined, [PlatypusPlotStatus.ACTIVE, PlatypusPlotStatus.INACTIVE, PlatypusPlotStatus.EVALUATING]);
    }

    generateDataMarkers(plots: DTOS.Plot[], userPlots: DTOS.Plot[], openMarkers: any[], plotSummaryData: any) {
        let markers: JSX.Element[] = [];

        if (plots) {
            plots.forEach((p, i) => {
                let colour = "#FFFFFF";

                if (p.private) {
                    colour = "#CCC8CC";
                }
                else {
                    switch (p.plotStatus.code) {
                        case PlatypusPlotStatus.ACTIVE: {
                            colour = "#444044"
                            break;
                        }
                        case PlatypusPlotStatus.INACTIVE: {
                            colour = "#444044"
                            break;
                        }
                        case PlatypusPlotStatus.EVALUATING: {
                            colour = "#17a2b8"
                            break;
                        }
                    }
                }

                let icon: MarkerIcon = {...this.props.defaultMarkerIcon};
                icon.strokeColor = this.props.mapMarkerOutlineColour;
                icon.fillColor = colour;

                const plotSummary = plotSummaryData && plotSummaryData[p.id] ? plotSummaryData[p.id].summaryData : undefined;

                let popup = <PlotSummary
                    children={InternalClassificationLink(`site/${p.id}`, 'ENTER SITE', undefined, `btn btn-sm btn-primary ml-auto`)}
                    dateFormat={this.props.defaultDateFormat}
                    plotSummary={plotSummary}
                    plot={p}
                    userMonitoring={userPlots && p && userPlots.some(p2 => p2.id == p.id)}
                    flagPlot={this.props.flagPlot}
                    toggleMarkerPopup={this.props.toggleMarkerPopup}
                />;

                const marker = <this.props.mapMarkerComponent
                    key={`mapmarker-${p.id}`}
                    icon={icon}
                    id={p.id}
                    interactive={true}

                    popup={popup}
                    position={{ lat: p.latitude, lng: p.longitude }}
                    isOpen={openMarkers ? openMarkers.indexOf(p.id) > -1 : false}
                    toggleMarkerPopup={this.props.toggleMarkerPopup}
                >
                </this.props.mapMarkerComponent>

                markers.push(marker);
            });
        }

        return markers;
    }

    generateNewMarker(openNewMarker: LatLong) {
        let newMarkerIcon: MarkerIcon;
        let newMarkerPopup: JSX.Element;
        let newMarker: JSX.Element;

        if (openNewMarker) {
            newMarkerIcon = {
                anchor: { x: 15, y: 3 },
                path: "M15 3 Q16.5 6.8 25 18 A12.8 12.8 0 1 1 5 18 Q13.5 6.8 15 3z",

                fillColor: '#DC1E1E',
                fillOpacity: 1,
                rotation: 180,
                scale: 1.5,
                strokeWeight: 3,
                strokeColor: this.props.mapMarkerOutlineColour
            };

            newMarkerPopup = <InfoWindow onCloseClick={this.props.toggleNewMarkerPopup.bind(this, undefined, undefined)}>
                <div className="wrapper-site-select-marker">
                    <PlotEdit
                        lat={openNewMarker.latitude}
                        lng={openNewMarker.longitude}
                        onCreatePlot={this.props.onCreatePlot}
                    />
                </div>
            </InfoWindow>;

            newMarker = <Marker
                position={{
                    lat: openNewMarker.latitude,
                    lng: openNewMarker.longitude
                }}
                icon={newMarkerIcon}>
                {newMarkerPopup}
            </Marker>
        }

        return newMarker;
    }

    render() {
        const mockActiveTab: ITab = {
            mapTabSettings: {
                mapTypeId: 'hybrid',
                mapEnablePlotCreation: true,
                showAddPlotEventButton: false,
                showMapOptions: false
            },
            bannerName: undefined,
            mapQueryStringToProps: undefined,
            needsAuthentication: undefined,
            pageTitle: undefined,
            pushIntoQueryString: undefined,
            route: undefined,
            shouldRerouteHome: undefined,
            showContentHeader: undefined,
            showFooter: undefined,
            showHeader: undefined,
            showSideBar: undefined,
            sidebarLink: undefined,
            type: Configuration.SiteSelectTab
        }

        const markers = this.generateDataMarkers(this.props.plots, this.props.userPlots, this.props.map.openMarkers, this.props.plotSummaryData);

        const newMarker = this.generateNewMarker(this.props.map.openNewMarker);

        return (
            <MapContainer
                activeTab={mockActiveTab}
                gridSize={15}
                googleMapURL={this.props.mapGoogleMapURL}
                mapType={this.props.mapType ? this.props.mapType : "normal"}
                markers={markers}
                newMarker={newMarker}
                //plots={this.props.plots}
                zoomInOnClick={true}

                changeTab={undefined}
            />
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageSiteSelectAllProps): PageSiteSelectPropsMapped => {

    return {
        map: state.map,
        plotSummaryData: state.summaryData.plotSummaryData,
        plots: state.data.plots,
        userPlots: state.data.userPlots,
        plotSaving: state.data.saving
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PageSiteSelectActionsMapped>({
        flagPlot: DashboardActionCreators.flagPlotRequest,
        getPlotSummaryData: DataActionCreators.getPlotSummaryDataRequest,
        getPlots: DataActionCreators.getPlotsRequest,
        onCreatePlot: DashboardActionCreators.createPlotRequest,
        toggleMarkerPopup: MapActionCreators.toggleMarkerPopupRequest,
        toggleNewMarkerPopup: MapActionCreators.toggleNewMarkerPopupRequest
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)<PageSiteSelectAllPropsInherited>(PageSiteSelect);